"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPointerMove = exports.onMouseUp = exports.onMouseDown = exports.onMouseRightClick = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.onMouseRightClick = (0, toolkit_1.createAction)('ON_MOUSE_RIGHT_CLICK');
exports.onMouseDown = (0, toolkit_1.createAction)('ON_MOUSE_DOWN');
exports.onMouseUp = (0, toolkit_1.createAction)('ON_MOUSE_UP');
exports.onPointerMove = (0, toolkit_1.createAction)('ON_POINTER_MOVE');
//# sourceMappingURL=mouse.js.map